import classNames from 'classnames'
import React, { Component } from 'react'

import DropdownWrapper from './DropdownStyle'

class Dropdown extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: null,
    }

    this.handleOpenDropdown = this.handleOpenDropdown.bind(this)
    this.handleCloseDropdown = this.handleCloseDropdown.bind(this)
    this.handleToggleDropdown = this.handleToggleDropdown.bind(this)
  }

  componentWillUnmount() {
    this.setState({
      isOpen: null,
    })
  }

  handleToggleDropdown() {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }))
  }

  handleOpenDropdown() {
    this.setState({
      isOpen: true,
    })
  }

  handleCloseDropdown() {
    this.setState({
      isOpen: false,
    })
  }

  render() {
    const { className, component, children, position, ...rest } = this.props
    const createdComponent = React.createElement(
      component,
      {
        className: classNames(className, 'dropdown'),
        onMouseEnter: this.handleOpenDropdown,
        onMouseLeave: this.handleCloseDropdown,
        onClick: this.handleToggleDropdown,
        style: { DropdownWrapper },
        ...rest,
      },
      // Dropdown parent
      React.isValidElement(children[0]) && React.cloneElement(children[0]),
      // Dropdown children
      // eslint-disable-next-line react/destructuring-assignment
      this.state.isOpen &&
        React.isValidElement(children[1]) &&
        React.cloneElement(children[1], {
          className: classNames('dropdown-menu show', children[1].props.className, className),
        })
    )

    return <DropdownWrapper>{createdComponent}</DropdownWrapper>
  }
}

export default Dropdown
